module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-131.c67d18e5.svg";